import stone from "./stone/index";
import alertes from './alertes/index'
import user from './user/index'

export default {
    stone,
    alertes,
    user
};
